import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";
import { OnboardingSteps } from './OnboardingSteps';

export class Event extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
      activeFaq: 0,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response1.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response2.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  toggleFaq = (index) => {
    this.setState(prev => ({ activeFaq: prev.activeFaq === index ? -1 : index }));
  };

  render() {
    const faqs = [
      { q: "❓ Это действительно бесплатно?", a: "Да. Никакой абонентской платы, процентов с броней. Оплата только за SMS и эквайринг (если подключите)." },
      { q: "❓ Как участник выбирает место?", a: "Он видит схему зала, нажимает на свободное место – видит цену, добавляет в корзину. Можно выбрать несколько мест." },
      { q: "❓ Можно ли добавить дополнительные услуги?", a: "Да. Питание, трансфер, проживание, сувениры – участник выбирает при регистрации." },
      { q: "❓ Как работает подписка на билеты?", a: "Если билеты распроданы, участник оставляет контакт и получает уведомление при появлении свободных мест." },
      { q: "❓ Нужно ли приложение?", a: "Нет, достаточно браузера. Но есть нативные приложения для iOS и Android." }
    ];

    return (
      <div class="fa-container">
        <Helmet>
          <title>Продажа билетов и выбор мест на мероприятия | Система бронирования — Planna</title>
          <meta name="description" content="Онлайн-продажа билетов, схема зала с выбором мест, подписка на билеты. Для концертов, конференций, фестивалей. Бесплатно." />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
          <script src="{{mainApiUrl}}landing.js"></script>
        </Helmet>
        {/* Hero */}
        <section className="hero">
          <div className="container fade-up">
            <div className="hero-badge">🎉 Для мероприятий: концерты, конференции, фестивали | Бесплатно навсегда</div>
            <h1>Управляйте продажей билетов <span className="highlight">визуально и без хлопот</span></h1>
            <p className="hero-description">Схема зала с выбором мест, продажа билетов онлайн, приём заявок по телефону. Автоматические напоминания, аналитика загрузки, подписка на билеты. Всё бесплатно.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {!this.state.isAuthenticated ? <a href="/authentication/register" className="btn-filled">Зарегистрироваться <i className="fas fa-arrow-right"></i></a> : <></>}
              <a href="/configcompany" className={this.state.isAuthenticated ? "btn-filled" : "btn-outline"}>Подключить мероприятие бесплатно <i className="fas fa-play"></i></a>
            </div>
          </div>
        </section>

        {/* Преимущества */}
        <section>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Всё для успешного проведения мероприятий</h2>
              <p className="section-subtitle">Принимайте бронирования любым способом и заполняйте залы на 100%</p>
            </div>
            <div className="grid-3 fade-up">
              <div className="benefit-card"><i className="fas fa-ticket-alt benefit-icon"></i><h3>Схема зала с выбором мест</h3><p>Участник видит план зала, выбирает конкретное место (ряд, сектор, VIP).</p></div>
              <div className="benefit-card"><i className="fas fa-chart-line benefit-icon"></i><h3>Аналитика продаж</h3><p>Популярные зоны, доход, количество проданных билетов – полный контроль.</p></div>
              <div className="benefit-card"><i className="fas fa-phone-alt benefit-icon"></i><h3>Брони по телефону</h3><p>Администратор вносит заказ вручную за 10 секунд. Всё в единой системе.</p></div>
              <div className="benefit-card"><i className="fas fa-calendar-week benefit-icon"></i><h3>Календарь загрузки площадки</h3><p>Цветовая индикация занятости зала по дням. Легко планировать даты.</p></div>
              <div className="benefit-card"><i className="fas fa-bell benefit-icon"></i><h3>Автоматические напоминания</h3><p>SMS, Telegram, push – снижение неявок на 70%.</p></div>
              <div className="benefit-card"><i className="fas fa-qrcode benefit-icon"></i><h3>QR-код на билете</h3><p>Гость сканирует на входе – автоматическая отметка.</p></div>
            </div>
          </div>
        </section>

        {/* Скриншоты (замените src) */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Как это работает</h2>
              <p className="section-subtitle">Интуитивно понятный интерфейс для вас и ваших гостей</p>
            </div>
            <div className="grid-2 fade-up" style={{ gap: '2.5rem' }}>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Схема+зала+с+местами" alt="Схема зала" /><div className="mockup-label">🎭 Выбор места на схеме</div></div>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Календарь+мероприятий" alt="Календарь" /><div className="mockup-label">📅 Календарь занятости зала</div></div>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Дополнительные+услуги" alt="Допуслуги" /><div className="mockup-label">🍷 Выбор питания, трансфера</div></div>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=QR-код+билета" alt="QR-код" /><div className="mockup-label">📱 QR-код для входа</div></div>
            </div>
          </div>
        </section>

        {/* Умные функции */}
        <section>
          <div className="container">
            {/* Схема зала */}
            <div className="smart-block fade-up" style={{ marginTop: 0 }}>
              <div style={{ flex: 1 }}>
                <i className="fas fa-chair" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Выбор конкретного места на схеме</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Участник видит схему зала: партер, балкон, VIP-ложи. Свободные места подсвечены. Выбирает ряд, место. Можно выбрать несколько мест для компании. При нажатии – цена, видимость сцены, доступность.</p>
                <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Цветовая индикация: свободно / занято / забронировано</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Разные цены для разных зон</li></ul>
              </div>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/500x300/F9FAFB/32bea6?text=Схема+зала" alt="Схема зала" /><div className="mockup-label">🎟️ Выберите место на плане</div></div></div>
            </div>

            {/* Календарь загрузки площадки */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-calendar-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Календарь загрузки площадки на месяц</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Вы видите занятость зала по дням. Гость выбирает мероприятие в удобную дату. Цветовая индикация: зелёные дни – свободно, красные – пик.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Оптимальное планирование мероприятий</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Легко добавлять новые даты</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Календарь+загрузки+месяца" alt="Календарь загрузки" /><div className="mockup-label">📅 Занятость зала по дням</div></div></div>
            </div>

            {/* Дополнительные услуги */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem', flexDirection: 'row-reverse' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-glass-cheers" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Дополнительные услуги при регистрации</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Участник может добавить питание (банкет, фуршет), трансфер до места, проживание в отеле, сувениры. Всё с прозрачными ценами. Вы увеличиваете средний чек.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Автоматический расчёт итоговой стоимости</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Удобно для гостей</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Дополнительные+услуги" alt="Допуслуги" /><div className="mockup-label">🍽️ Добавьте питание или трансфер</div></div></div>
            </div>

            {/* Подписка на билеты */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-bell" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Подписка на билеты</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Если билеты распроданы, гость оставляет контакт. Как только кто-то отказывается или освобождается место – мгновенное уведомление. Гость успевает купить билет первым.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Ни одного потерянного зрителя</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Автоматическое заполнение отказов</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Подписка+на+билеты" alt="Подписка" /><div className="mockup-label">🔔 Уведомление о появлении билетов</div></div></div>
            </div>

            {/* Два календаря при бронировании */}
            <div className="smart-block fade-up" style={{ background: 'linear-gradient(110deg, rgba(50,190,166,0.05) 0%, #FFFFFF 100%)', marginTop: '2rem' }}>
                <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Два+календаря" alt="Два календаря" /><div className="mockup-label">📅 Два календаря – один выбор</div></div></div>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-eye" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>При бронировании — два календаря рядом</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Система показывает гостю его личные события из Google и Apple календаря (только в приложении) и даты доступных мероприятий. Гость сразу видит, когда он свободен, и выбирает подходящий день.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Без конфликтов с личными планами</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Удобный выбор даты</li></ul>
                </div>
            </div>
          </div>
        </section>

        {/* Типы мероприятий */}
        <section style={{ background: '#FEF9F0' }}>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Подходит для любых мероприятий</h2>
            <div className="stats-grid" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem' }}>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center' }}><i className="fas fa-music"></i><h3>Концерты</h3><p>Схема зала, продажа билетов</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center' }}><i className="fas fa-chalkboard-teacher"></i><h3>Конференции</h3><p>Регистрация участников</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center' }}><i className="fas fa-glass-cheers"></i><h3>Вечеринки</h3><p>Бронирование столов, допуслуги</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center' }}><i className="fas fa-palette"></i><h3>Выставки</h3><p>Продажа билетов по зонам</p></div>
            </div>
          </div>
        </section>

        {/* Мобильные приложения */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="smart-block fade-up" style={{ background: 'white' }}>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="{{mainApiUrl}}mobile1.png" alt="Мобильное приложение" /><div className="mockup-label">📱 Управляйте мероприятием со смартфона</div></div></div>
              <div style={{ flex: '1.2' }}>
                <i className="fas fa-mobile-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Мобильные приложения для всех</h3>
                <p>Ваши сотрудники и гости могут пользоваться сервисом через нативные приложения для iOS и Android.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для организатора:</strong> продажа билетов, аналитика, уведомления</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для гостей:</strong> выбор места, покупка, QR-билет, напоминания</li>
                </ul>
                <div className="app-badges" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px', margin: '20px 0 0 0' }}>
                  <a href="https://apps.apple.com/ru/app/id6773870898" target="_blank"><img src="{{mainApiUrl}}appleru.png" alt="App Store" /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.planna.app" target="_blank"><img src="{{mainApiUrl}}googleru.png" alt="Google Play" /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <OnboardingSteps
              isRegistered={this.state.isAuthenticated}
              hasCompany={this.state.companies.length > 0}
              hasServices={this.state.services.length > 0}
              hasResources={this.state.resources.length > 0}
              servicesCount={this.state.services.length}
              resourcesCount={this.state.resources.length}
              companyId={this.state.services.length > 0 ? this.state.companies[0].id : 0}
            />
          </div>
        </section>

        {/* FAQ */}
        <section>
          <div className="container fade-up">
            <h2 className="section-title" style={{ textAlign: 'center' }}>Частые вопросы</h2>
            <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
              {faqs.map((faq, idx) => (
                <div key={idx} className={`faq-item ${this.state.activeFaq === idx ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => this.toggleFaq(idx)}>{faq.q} <i className="fas fa-chevron-down"></i></div>
                  <div className="faq-answer">{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section style={{ background: 'linear-gradient(115deg, #1F2937 0%, #32bea6 100%)', color: 'white' }}>
          <div className="container fade-up" style={{ textAlign: 'center', padding: '80px 0' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '800' }}>Начните продавать билеты онлайн уже сегодня</h2>
            <p style={{ fontSize: '1.1rem', margin: '1rem auto 2rem', maxWidth: '600px', opacity: 0.9 }}>Больше никакой ручной работы. Ваш зал будет заполнен всегда.</p>
            <a href="/authentication/register" className="btn-filled btn-white">Зарегистрироваться <i className="fas fa-arrow-right"></i></a>
            <a href="/configcompany" className="btn-filled btn-white">Подключить бизнес бесплатно <i className="fas fa-arrow-right"></i></a>
            <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>Настройка за 15 минут. QR-код, напоминания, аналитика — 0₽</p>
          </div>
        </section>

        {/*
        <h2 class="main2">Как это работает за 5 минут</h2>
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (места)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>
        */}
      </div>
    );
  }
}
